import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DataTableHelper from "../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import Select from "react-select";
import {
  resourcesSalidasConfigs,
  activeBranch,
  duplicateBranch,
} from "../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../helpers/alerts/alertHelper";
import { getPolicyUser } from "../../helpers/api_helper";
import { Container, ButtonGroup, Button, Row, Col } from "reactstrap";
import { getStorageCompany, getStorageUser } from "../../helpers/api_helper";

const SalidasConfigurations = () => {
  const policy = getPolicyUser();
  const authUser = getStorageUser();
  const company = getStorageCompany();
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalDetail, setModalDetail] = useState({ show: false, id: null });
  const days = [
    { value: 1, name: "Lunes" },
    { value: 2, name: "Martes" },
    { value: 3, name: "Miércoles" },
    { value: 4, name: "Jueves" },
    { value: 5, name: "Viernes" },
    { value: 6, name: "Sábado" },
    { value: 7, name: "Domingo" },
  ];
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    companySession: company.id,
    day: 1,
  });
  const [items, setItems] = useState([]);
  const [item, setItem] = useState({
    id: 0,
    ramal_id: null,
    timer: "",
    type: "",
    operator_id: null,
    unit_id: null,
    destination: "",
    ruta_id: null,
    time_start: "",
    time_end: "",
    frequency: 0,
    repeat: false,
    daysOfWeek: {
      lunes: false,
      martes: false,
      miercoles: false,
      jueves: false,
      viernes: false,
      sabado: false,
      domingo: false,
    },
  });

  const fetchConfigurations = useCallback((filters) => {
    let params = { params: filters };
    setPending(true);
    if (filters.day) {
      resourcesSalidasConfigs("get", params).then((response) => {
        setItems(response.data);
        setDataPag(response.meta);
        setPending(false);
      });
    } else {
      setPending(false);
    }
  }, []);

  const realodData = () => {
    fetchConfigurations(filters);
  };

  useEffect(() => {
    fetchConfigurations(filters);
  }, [filters]);

  const addUpd = (row) => {
    console.log({ row });
    if (row.id) {
      setItem(row);
      setModal({ ...modal, show: true, update: true });
    } else {
      setModal({ ...modal, show: true, update: false });
    }
  };

  const destroy = (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      resourcesSalidasConfigs("del", id, id).then((response) => {
        Alert(response.message, response.status);
        if (response.status) {
          setItems(items.filter((i) => i.id != id));
        }
      });
    });
  };

  const columns = Columns(
    addUpd,
    destroy,
    items,
    setItems,
    duplicateBranch,
    authUser,
    setModalDetail,
    modalDetail,
    days[filters.day - 1]
  );
  document.title = "Programación de salidas | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Programación de salidas"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <Col md={6}>
                <ButtonGroup>
                  <Button
                    className="btn btn-sm btn-gray"
                    onClick={() => setFilters({ ...filters, day: 1 })}
                    active={filters.day == 1}
                  >
                    <i className="fa fa-calendar-check"></i> Lunes
                  </Button>
                  <Button
                    className="btn btn-sm btn-gray"
                    onClick={() => setFilters({ ...filters, day: 2 })}
                    active={filters.day == 2}
                  >
                    <i className="fa fa-calendar-check"></i> Martes
                  </Button>
                  <Button
                    className="btn btn-sm btn-gray"
                    onClick={() => setFilters({ ...filters, day: 3 })}
                    active={filters.day == 3}
                  >
                    <i className="fa fa-calendar-check"></i> Miércoles
                  </Button>
                  <Button
                    className="btn btn-sm btn-gray"
                    onClick={() => setFilters({ ...filters, day: 4 })}
                    active={filters.day == 4}
                  >
                    <i className="fa fa-calendar-check"></i> Jueves
                  </Button>
                  <Button
                    className="btn btn-sm btn-gray"
                    onClick={() => setFilters({ ...filters, day: 5 })}
                    active={filters.day == 5}
                  >
                    <i className="fa fa-calendar-check"></i> Viernes
                  </Button>
                  <Button
                    className="btn btn-sm btn-gray"
                    onClick={() => setFilters({ ...filters, day: 6 })}
                    active={filters.day == 6}
                  >
                    <i className="fa fa-calendar-check"></i> Sábado
                  </Button>
                  <Button
                    className="btn btn-sm btn-gray"
                    onClick={() => setFilters({ ...filters, day: 7 })}
                    active={filters.day == 7}
                  >
                    <i className="fa fa-calendar-check"></i> Domingo
                  </Button>
                </ButtonGroup>
              </Col>
              <Col md={4} className="text-end">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => addUpd(item)}
                >
                  <i className="fas fa-solid fa-plus"></i> Agregar
                </button>
              </Col>

              <div className="p-2 "></div>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={item}
            setItem={setItem}
            authUser={authUser}
            filtersData={filters}
            setFiltersData={setFilters}
            realodData={realodData}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default SalidasConfigurations;
